import { Slider, Text } from '@volkswagen-onehub/components-core';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import useFiltersQuery from '../../api/use-filters-query';
import { useSelectedFilterStore } from '../../store/filtersv2';
import { getLang, getTranslations } from '../../translations';
import { FiltersResponse, MinMaxOption } from '../../types/globalapi/filters';
import { ResponseSelector } from '../../types/globalapi/response-selector';
import { useFeatureServices } from '../../use-feature-services';
import { formatCurrency } from '../../utils/format';
import { getSingleSelectedDealer } from '../../utils/get-single-selected-dealer';
import { createConfiguration, createConstantData, createPartner } from '../../utils/get-tracking-event-data';

export const PriceSlider = () => {
  const lang = getLang();
  const { labels } = getTranslations();

  const getPriceRange: ResponseSelector<FiltersResponse, MinMaxOption> = res => res.price;
  const { isLoading, data } = useFiltersQuery<FiltersResponse, MinMaxOption>({select: getPriceRange});
  const { selected, selectFilter } = useSelectedFilterStore();

  const { tracking } = useFeatureServices();
  const partner = getSingleSelectedDealer(); // nts may need to be updated

  const min = Math.floor((data as MinMaxOption).min/1000)*1000;
  const max = Math.round((data as MinMaxOption).max/1000)*1000;

  const handleChange = (val: number) => {
    if (val === max) {
      selectFilter("price", undefined);
    } else {
      selectFilter("price", val);
    }

    tracking.track('VWBasic_FilterSelect_Click', {
      ...createConstantData(),
      configuration: createConfiguration(),
      partner: createPartner(partner),
      link: {
        url: window.location.href,
        name: labels.price
      },
      filter: {
        type: 'range',
        name: labels.price,
        values: [0, val],
        lowerbound: 0,
        upperbound: val,
      }
    });
  };

  return (
    isLoading
    ? <Skeleton />
    : <>
      <Text>{labels.maximum_price} {formatCurrency(selected?.price || max, false, lang)}</Text>
      <Slider
        min={min}
        max={max}
        defaultValue={selected?.price || max}
        ariaLabel={labels.price}
        getValueText={value => formatCurrency(value, false, lang)}
        onChange={handleChange}
        step={1000}
        hideMinMax
      />
    </>
  );
}
